<template>

  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card card-form">
          <div class="card-header">
            <div class="row">
              <div class="col">
                <div class="alert alert-info">
                  {{ $t("auto.autoTexPassport.label") }}
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-lg-4 col-md-6">

                <div class="form-group">
                  <label>{{ $t("auto.autoTexPassport.texPassportNumber") }} <span
                      class="red">*</span></label>
                  <input type="text" class="form-control" v-model="autoDto.texPassportNum"
                         @input="formatToUpperAndNumbers($event, 'texPassportNum')"
                         :class="{invalid : $v.autoDto.texPassportNum.$error}"/>
                  <div class="red" v-if="$v.autoDto.texPassportNum.$error">
                    {{ $t("auto.autoTexPassport.validation.texPassportNumber") }}
                  </div>
                </div>

                <div class="form-group">
                  <label>{{ $t("auto.autoTexPassport.madeYear") }} <span class="red">*</span></label>
                  <numeric-input class="form-control" v-model="autoDto.madeYear"
                                 :class="{invalid : $v.autoDto.madeYear.$error}"
                                 :controls="false" :precision="0"></numeric-input>
                  <div class="red" v-if="$v.autoDto.madeYear.$error">
                    {{ $t("auto.autoTexPassport.validation.madeYear") }}
                  </div>
                </div>

                <div class="form-group">
                  <label>{{ $t("auto.autoTexPassport.shasseNum") }} </label>
                  <input type="text" class="form-control" v-model="autoDto.shasseNum"
                         :class="{invalid : $v.autoDto.shasseNum.$error}"/>
                  <div class="red" v-if="$v.autoDto.shasseNum.$error">
                    {{ $t("auto.autoTexPassport.validation.shasseNum") }}
                  </div>
                </div>

                <div class="form-group">
                  <label>{{ $t("auto.autoTexPassport.bodyNum") }} </label>
                  <input type="text" class="form-control" v-model="autoDto.bodyNum"
                         :class="{invalid : $v.autoDto.bodyNum.$error}"/>
                  <div class="red" v-if="$v.autoDto.bodyNum.$error">
                    {{ $t("auto.autoTexPassport.validation.bodyNum") }}
                  </div>
                </div>




              </div>
              <div class="col-12 col-lg-4 col-md-6">
                <div class="form-group">
                  <label>{{ $t("auto.autoTexPassport.fullWeight") }} </label>
                  <input type="text" class="form-control" v-model="autoDto.fullWeight"
                         :class="{invalid : $v.autoDto.fullWeight.$error}"/>
                  <div class="red" v-if="$v.autoDto.fullWeight.$error">
                    {{ $t("auto.autoTexPassport.validation.fullWeight") }}
                  </div>
                </div>

                <div class="form-group">
                  <label>{{ $t("auto.autoTexPassport.highWeight") }} </label>
                  <input type="text" class="form-control" v-model="autoDto.highWeight"
                         :class="{invalid : $v.autoDto.highWeight.$error}"/>
                  <div class="red" v-if="$v.autoDto.highWeight.$error">
                    {{ $t("auto.autoTexPassport.validation.highWeight") }}
                  </div>
                </div>

                <div class="form-group">
                  <label>{{ $t("auto.autoTexPassport.engineNum") }} </label>
                  <input type="text" class="form-control" v-model="autoDto.engineNum"
                         :class="{invalid : $v.autoDto.engineNum.$error}"/>
                  <div class="red" v-if="$v.autoDto.engineNum.$error">
                    {{ $t("auto.autoTexPassport.validation.engineNum") }}
                  </div>
                </div>

                <div class="form-group">
                  <label>{{ $t("auto.autoTexPassport.fuelType") }} </label>
                  <select class="form-control" v-model="autoDto.fuelType">
                    <option :value="option.key" v-for="option in fuelTypes" :key="option.key">
                      {{ option.name }}
                    </option>
                  </select>
                </div>

              </div>
              <div class="col-12 col-lg-4 col-md-6">

                <div class="form-group">
                  <label>{{ $t("auto.autoTexPassport.governmentNum") }} <span
                      class="red">*</span></label>
                  <input type="text" class="form-control" v-model="autoDto.governmentNum"
                         @input="formatToUpperAndNumbers($event, 'governmentNum')"
                         :class="{invalid : $v.autoDto.governmentNum.$error}"/>
                  <div class="red" v-if="$v.autoDto.governmentNum.$error">
                    {{ $t("auto.autoTexPassport.validation.governmentNum") }}
                  </div>
                </div>


                <div class="form-group">
                  <label>{{ $t("auto.autoTexPassport.autoName") }} <span class="red">*</span></label>
                  <input type="text" class="form-control" v-model="autoDto.name"
                         :class="{invalid : $v.autoDto.name.$error}"/>
                  <div class="red" v-if="$v.autoDto.name.$error">
                    {{ $t("auto.autoTexPassport.validation.autoName") }}
                  </div>
                </div>

                <div class="form-group">
                  <label>{{$t("auto.autoType.typeOfCar")}} <span class="red">*</span></label>
                  <select class="form-control" v-model="autoDto.vehicleType"
                          :class="{invalid : $v.autoDto.vehicleType.$error}">
                    <option :value="option.key" v-for="option in vehicleTypes" :key="option.key">
                      {{option.name}}
                    </option>
                  </select>
                  <div class="red" v-if="$v.autoDto.vehicleType.$error">
                    {{$t("auto.autoType.typeOfCar")}}
                  </div>
                </div>


                <div class="form-group">
                  <label>{{ $t("auto.autoTexPassport.autoColor") }} <span class="red">*</span></label>
                  <input type="text" class="form-control" v-model="autoDto.autoColor"
                         :class="{invalid : $v.autoDto.autoColor.$error}"/>
                  <div class="red" v-if="$v.autoDto.autoColor.$error">
                    {{ $t("auto.autoTexPassport.validation.autoColor") }}
                  </div>
                </div>

                <div class="form-group">
                  <label>{{ $t("auto.autoTexPassport.address") }} <span class="red">*</span></label>
                  <input type="text" class="form-control" v-model="autoDto.address"
                         :class="{invalid : $v.autoDto.address.$error}"/>
                  <div class="red" v-if="$v.autoDto.address.$error">
                    {{ $t("auto.autoTexPassport.validation.address") }}
                  </div>
                </div>

              </div>

            </div>

            <div class="row">
              <div class="col-12">
                <div class="section-header">
                  <h4>{{$t("auto.autoDocs")}}</h4>
                </div>

                <div class="form-group">
                  <div class="d-flex">
                    <div class="mt-2" :class="{invalid : $v.autoDto.ownerType.$error}">
                      <div class="form-check form-check-radio checkbox-inline pl-0"
                           style="margin-left:-0.8rem">
                        <label class="form-check-label">
                          <input class="form-check-input" type="radio" name="ownerType"
                                 value="Physical" v-model="autoDto.ownerType">
                          <span class="form-check-sign"></span>
                          {{ $t("expert2.field.ownerType.physical") }}
                        </label>
                      </div>
                      <div class="form-check form-check-radio checkbox-inline">
                        <label class="form-check-label">
                          <input class="form-check-input" type="radio" name="ownerType"
                                 value="Legal" v-model="autoDto.ownerType">
                          <span class="form-check-sign"></span>
                          {{ $t("expert2.field.ownerType.legal") }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="red" v-if="$v.autoDto.ownerType.$error">
                    {{ $t("realEstate.validation.valueType") }}
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-4 col-md-6">
                <div class="form-group">
                  <label>{{ $t("auto.autoTexPassport.ownerName") }} <span class="red">*</span></label>
                  <input type="text" class="form-control" v-model="autoDto.ownerName"
                         :class="{invalid : $v.autoDto.ownerName.$error}"/>
                  <div class="red" v-if="$v.autoDto.ownerName.$error">
                    {{ $t("auto.adress") }}
                  </div>
                </div>

              </div>

              <div class="col-12 col-lg-4 col-md-6">

                <template v-if="autoDto.ownerType === 'Physical'">
                  <div class="form-group">
                    <label>{{ $t('auto.autoTexPassport.pinflNumber') }} <span
                        class="red">*</span></label>
                    <pinfl-input
                        :pinfl.sync="autoDto.pinflNumber"
                        :validation-field="$v.autoDto.pinflNumber"
                        :with-birt-date="true"
                        @birth-date-complete-event="handleBirthDate"
                    />
                  </div>
                </template>

                <template v-if="autoDto.ownerType === 'Legal'">
                  <div class="form-group">
                    <label>{{ $t('auto.autoTexPassport.identificationNumber') }} <span
                        class="red">*</span></label>
                    <the-mask type="text" class="form-control"
                              mask="#########" :masked="true"
                              v-model="autoDto.identificationNumber"
                    ></the-mask>
                    <div class="red" v-if="$v.autoDto.identificationNumber.$error">
                      {{ $t("auto.autoTexPassport.validation.identificationNumber") }}
                    </div>
                  </div>
                </template>
              </div>

              <div class="col-12 col-lg-4 col-md-6">

                <template v-if="autoDto.ownerType === 'Physical'">
                  <div class="form-group">
                    <label>{{ $t('auto.autoTexPassport.birthDate') }} <span
                        class="red">*</span></label>
                    <datepicker class="form-control" format="dd/MM/yyyy"
                                v-model="autoDto.birthDate"
                                :clear-button="true"
                    ></datepicker>
                    <div class="red" v-if="$v.autoDto.birthDate.$error">
                      {{ $t("auto.autoTexPassport.validation.birthDate") }}
                    </div>
                  </div>
                </template>
              </div>

              <template v-if="!isPageLoadInit">
                <AssetDropZone code="texPassportDropZone" label="auto.texPassport"
                               folder="TexPassport" :folderName="'Auto'"
                               :data="autoDto.texPassportFiles"
                               @change="(files) => {autoDto.texPassportFiles = files}"
                />
              </template>

            </div>


            <div class="row mt-5">
              <div class="col-12 btns-box">
                <button class="all-btn delete-btn" @click="cancel" :disabled="processing" v-tooltip="'Orqaga'">
                  <i class="fa fa-undo"></i>
                  {{ $t("action.cancel") }}
                </button>
                <button class="all-btn add-btn" @click="save" :disabled="processing" >
                  {{ $t("action.save") }}
                </button>
                <button class="all-btn delete-btn table-action" @click="showReject(autoDto)" :disabled="processing"  v-tooltip="'Рад этиш'">
                  {{ $t("expert2.action.reject") }}
                  <i class="fa fa-remove"></i>
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <RejectReasonModal :title="'Tex бекор қилиш'"
                       :id="autoDto ? autoDto.id: null"
                       @handle-reject-save="handleRejectSave"
                       @handle-reject-cancel="handleRejectCancel"
    />
  </div>
</template>

<script>
import {numericTypes} from '@/shared/constants/mask'
import {required, requiredUnless, minLength} from 'vuelidate/lib/validators';
import initFilterModel from '@/shared/filter';
import {TheMask} from 'vue-the-mask';
import Datepicker from 'vuejs-datepicker';
import {pinflNumber} from "@/shared/pinfl-birthdate/pinfl-birthdate-validator";
import PinflInput from "@/components/PinflInput.vue";
import AssetDropZone from "@/views/asset/AssetDropZone.vue";
import RejectReasonModal from "@/components/RejectReasonModal.vue";

export default {
  name: "TexPassportAddEdit",
  components: {
    AssetDropZone,
    TheMask,
    Datepicker,
    RejectReasonModal,
    PinflInput
  },
  props: {
    parentId: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      processing: false,
      isPageLoadInit: false,
      numericTypes: numericTypes,
      show: false,
      autoTypeFilter: initFilterModel(),
      autoDto: {
        id: null,
        texPassportFiles: [],
        parentId: this.$route.params.id,
        ownerType: 'Physical',
        name: '',
      },
      fuelTypes: [],
      vehicleTypes: [],
      status: null,
    }
  },
  validations() {
    return {
      autoDto: {
        madeYear: {
          required: required
        },
        governmentNum: {
          required: required
        },
        texPassportNum: {
          required: required
        },
        shasseNum: {
          required: required
        },
        bodyNum: {
          required: required
        },
        fullWeight: {
          required: required
        },
        highWeight: {
          required: required
        },
        engineNum: {
          required: required
        },
        name: {
          required: required
        },
        autoColor: {
          required: required
        },
        vehicleType: {
          required: required
        },
        ownerType: {
          required: required
        },
        address: {
          required: required
        },
        ownerName: {
          required: required
        },
        pinflNumber: {
          required: requiredUnless(() => {
            return this.autoDto.ownerType === 'Legal';
          }),
          pinflNumber: pinflNumber(this.autoDto.ownerType === 'Legal')
        },
        birthDate: {
          required: requiredUnless(() => {
            return this.autoDto.ownerType === 'Legal';
          })
        },
        identificationNumber: {
          required: requiredUnless(() => {
            return this.autoDto.ownerType === 'Physical';
          }),
          minLength: minLength(9)
        },
      }
    };
  },
  computed: {},
  methods: {
    init() {
      const vm = this;
      const id = this.$route.params.id;
      if (id && id > 0) {
        vm.isPageLoadInit = true;
        this.$http.get('auto_tex_passport/' + id).then(function (data) {
          vm.autoDto = data.data;
          vm.isPageLoadInit = false;
        });
      }

    },
    handleBirthDate(birthDate) {
      this.autoDto = {
        ...JSON.parse(JSON.stringify(this.autoDto)),
        birthDate: birthDate
      }
    },
    addClient() {
      this.$router.push('/tex-passport/edit/' + this.autoDto.parentId);
    },

    cancel() {
      this.$router.push('/config/auto');
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.autoDto.madeYear > new Date().getFullYear()) {
        this.$swal({
          title: this.$t('messages.common.warning'),
          text: "Машина ишлаб чиқарилган йили ҳозирги йилдан катта бўлиши мумкин эмас!",
          type: 'warning'
        });
        return;
      }

      this.processing = true;

      this.$http.post('auto_tex_passport/save', this.autoDto)
          .then(res => {
            this.processing = false;
            if (res.data.status !== 'SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t(res.data.message),
                type: 'warning'
              });
              return;
            }
            this.$swal({
              title: this.$t('messages.common.success'),
              text: this.$t('auto.success'),
              type: 'success'
            });
            this.autoDto.id = res.data.data;
            this.onObject();
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('auto.error'),
              type: 'error'
            });
            this.processing = false;
          });
    },
    onObject() {
      this.$router.push('/config/auto');
    },
    getAutoFuelType() {
      this.$http.get('/fuel-type-car').then(response => {
        this.fuelTypes = response.data;

      }, err => {
        console.log(err)
      });
    },

    getVehiclesType() {
      this.$http.get('/vehicle-type-for-egov').then(response => {
        this.vehicleTypes = response.data;
      }, err => {
        console.log(err)
      });
    },

    onShowAlert(type, message) {
      this.$swal({
        position: 'top-end',
        type: type,
        text: message,
        showConfirmButton: false,
        timer: 3000
      });
    },

    formatToUpperAndNumbers(event, fieldName) {
      if(this.autoDto.hasOwnProperty(fieldName)) {
        this.autoDto[fieldName] = event.target.value.toUpperCase().replace(/[^A-Z0-9-]/g, '');
      }
    },

    showReject(result) {
      this.$eventBus.$emit('showRejectReasonModal', true)
      this.currentRealEstate = result
    },
    handleRejectSave(realEstateReasonDesc) {
      this.processing = true;
      this.$http.post('auto_tex_passport/status/reject', {
        id: this.currentRealEstate.id,
        texpasportDatabaseStatusType: 'DEACTIVATED',
        reasonCancellation: realEstateReasonDesc
      }).then(res => {
        if (res && res.data && res.data.status === 'SUCCESS') {
          this.$eventBus.$emit('showRejectReasonModal', false);
          this.$swal({
            title: this.$t('messages.common.success'),
            text: "Автотранспорт техпаспорти муваффақиятли бекор қилинган",
            type: 'success'
          });
          this.currentRealEstate.status = 'Rejected';
        } else {
          this.$swal({
            title: this.$t('messages.common.warning'),
            text: "Автотранспорт техпаспортни бекор қилишда хатолик",
            type: 'warning'
          });
          this.$eventBus.$emit('showRejectReasonModal', false);
        }
        this.processing = false;
        this.currentRealEstate = null
      }, () => {
        this.$swal({
          title: this.$t('messages.common.error'),
          text: "Автотранспорт техпаспортни бекор қилишда хатолик",
          type: 'error'
        });
        this.$eventBus.$emit('showRejectReasonModal', false);
        this.processing = false;
        this.currentRealEstate = null
      })
    },
    handleRejectCancel() {
      this.currentRealEstate = null
    },

  },
  created() {
    this.init();
    this.getAutoFuelType();
    this.getVehiclesType();
  }
}
</script>

<style scoped>

</style>
